import i18n from "../../../i18n";
import downloadItem from "../../../Utils/downloadItem";
import { Notification } from "../../../Utils/Notification";
import { getProvinceCode } from "../../../Utils/ProvinceCode";

export const setMap = (state, action) => {
  return { ...state, map: action.map };
};

export const mapViewState = (state, action) => {
  // action.mapState MUST be: PLAN_VIEW || LIVE_TRACK
  return { ...state, mapViewState: action.mapState };
};

export const addPlanId = (state, action) => {
  return { ...state, planId: action.id };
};

export const toggleSocketIsListeningToMap = (state, action) => {
  return { ...state, socketIsListeningToMap: action.state };
};

export const clearState = (state, action, initialState) => {
  return { ...state, [action.stateName]: initialState[action.stateName] };
};

export const changeMapDrawerTab = (state, action) => {
  return { ...state, planViewMapDrawerTab: action.tab };
};

export const stopWorkingButtons = (state, action) => {
  return { ...state, cantDoAnything: action.state };
};

export const setCantDoEditAfterGetExternal = (state, action) => {
  return { ...state, cantDoEditAfterGetExternal: Boolean(action.state) };
};

export const changeContextMenu = (state, action) => {
  if (action.value === state.ContextMenu[action.key]) {
    return state;
  }
  const updateValue = {
    ...state.ContextMenu,
    [action.key]: action.value,
  };
  return { ...state, ContextMenu: updateValue };
};

export const logHistory = (state, action) => {
  return {
    ...state,
    ChangedPolygons: {
      ...state.ChangedPolygons,
      LogHistory: [...state.ChangedPolygons.LogHistory, action.data],
    },
  };
};

export const toggleMenuItem = (state, action) => {
  if (action.value === state.MenuItems[action.key]) {
    return state;
  }
  const updateValue = {
    ...state.MenuItems,
    [action.key]: action.value,
  };
  if (action.key === "pin") {
    if (action.value === true && state.MenuItems.polygonPins === 2) {
      updateValue.polygonPins = 1;
    }
  }
  if (action.key === "polygonPins") {
    if (action.value === 2) {
      updateValue.pin = false;
    }
  }

  return { ...state, MenuItems: updateValue };
};

export const screenMustFreeze = (state, action) => {
  return { ...state, screenFreeze: action.freeze };
};

export const changeDataForPlanReset = (state, action) => {
  const newMainPlan = JSON.parse(JSON.stringify(state.mainPlanData));
  newMainPlan[action.key] = action.data;
  return { ...state, mainPlanData: newMainPlan };
};

export const getLightPlanInfo = (state, action) => {
  const updateValue = {
    error: null,
    request: action.planId,
  };
  return {
    ...state,
    lightPlanInfo: { ...state.lightPlanInfo, ...updateValue },
  };
};
export const getLightPlanInfoSuccess = (state, action) => {
  const updateValue = {
    error: null,
    request: null,
    response: action.res?.entity,
  };
  return {
    ...state,
    lightPlanInfo: { ...state.lightPlanInfo, ...updateValue },
    wareHouse: [
      action.res?.entity?.address?.latitude,
      action.res?.entity?.address?.longitude,
    ],
  };
};
export const getLightPlanInfoFail = (state, action) => {
  const updateValue = {
    error: action.error,
    request: null,
    response: null,
  };
  return {
    ...state,
    lightPlanInfo: { ...state.lightPlanInfo, ...updateValue },
  };
};

export const getPlanInfo = (state, action) => {
  const updateValue = {
    request: action.planId,
    error: null,
  };
  return { ...state, PlanInfo: { ...state.PlanInfo, ...updateValue } };
};
export const getPlanInfoSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.entity,
    error: null,
  };

  const planData = action.res.entity.data;
  (planData?.polygons || []).forEach((polygon) => {
    if (polygon?.sentByGetExternal == null) return;
    (polygon.subPlan?.pins || []).forEach((pin) => {
      pin.sentByGetExternal = polygon.sentByGetExternal;
    });
  });

  const mutatePlan = JSON.parse(JSON.stringify(planData));
  delete mutatePlan.hasLastHour;

  // let adjustedPins = GetStorage("USER_ADJUSTED_PIN");
  // const changedPolygon = adjustedPins ? state.ChangedPolygons["TotalChangedPolygons"] : [];
  // if (adjustedPins) {
  //   JSON.parse(adjustedPins).forEach(item => {
  //     const foundedPoly = mutatePlan.polygons.find(poly => poly.subPlan.uid === item.uid);
  //     if (foundedPoly) {
  //       const foundedPin = foundedPoly.subPlan.pins.find(pin => pin.packetId === item.PacketId);
  //       if (foundedPin) {
  //         foundedPin.noGeo = "ADJUST";
  //         foundedPin.draggable = true;
  //         foundedPin.priority = "0";
  //         foundedPin.coordinates = item.NewCoord;

  //         const isExist = changedPolygon.find(id => id === foundedPin.uid);
  //         if (!Boolean(isExist)) {
  //           changedPolygon.push({ uid: foundedPin.uid });
  //         };
  //       };
  //     };
  //   });
  // };

  const updateSelectedPin = state.MapItems;

  if (state.MapItems.selectedPin || state.MapItems.selectedPolygon) {
    // update ** selectedPin OR selectedPolygon ** when plan is updating
    if (state.MapItems.selectedPin) {
      const pin = state.MapItems.selectedPin;
      const { packetId, uid } = pin;
      const poly = mutatePlan.polygons.find((poly) => poly.subPlan.uid === uid);
      if (poly) {
        const newSelectedPin = poly.subPlan.pins.find(
          (newPin) => newPin.packetId === packetId
        );
        if (newSelectedPin) {
          updateSelectedPin.selectedPin = newSelectedPin;
        }
      } else {
        updateSelectedPin.selectedPin = false;
      }
    }

    if (state.MapItems.selectedPolygon) {
      const polygon = state.MapItems.selectedPolygon;
      const newSelectedPolygon = mutatePlan.polygons.find(
        (poly) => poly.subPlan.uid === polygon.subPlan.uid
      );
      if (newSelectedPolygon) {
        updateSelectedPin.selectedPolygon = newSelectedPolygon;
      } else {
        updateSelectedPin.selectedPolygon = false;
      }
    }
  }

  console.log("updateValue", updateValue);

  return {
    ...state,
    PlanInfo: updateValue,
    ModifyActions: action.res?.entity?.modifyActions,
    mainPlanData: mutatePlan,
    MapItems: updateSelectedPin,
    wareHouse: action.res.wareHouseCoordinates,
    PlanHasLastPin: action.res.entity.data.hasLastHour,
    planProvinceCode: getProvinceCode(
      action.res.CityName || action.res.cityName
    ),
    PinSetting: {
      ...state.PinSetting,
      flyToPin: [],
      MultiSelect: [],
      SetRemainPin: [],
      NotMetsCreatePolygon: [],
      RemainsCreatePolygon: [],
      ReAssign: false,
      AssignRemainPin: [],
      AssignNotMetPin: false,
      deletedPinNoPolygon: null,
      showListOfPolygonPins: false,
    },
    PolygonSetting: {
      ...state.PolygonSetting,
      flyToCoords: [],
      MergePolygons: [],
    },
  };
};

export const getPlanInfoFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };

  return { ...state, PlanInfo: updateValue };
};

export const removeDriverFromPolygon = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, removeDriverPolygon: updateValue };
};
export const removeDriverFromPolygonSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };

  Notification.pushNotif(
    i18n.t("Notification.removeDriverPlanSuccessfully"),
    "success"
  );

  return { ...state, removeDriverPolygon: updateValue };
};
export const removeDriverFromPolygonFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };

  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );

  return { ...state, removeDriverPolygon: updateValue };
};

export const removeDistributorFromPolygon = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, removeDistributorPolygon: updateValue };
};
export const removeDistributorFromPolygonSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };

  Notification.pushNotif(
    i18n.t("Notification.removeDistributorPlanSuccessfully"),
    "success"
  );

  return { ...state, removeDistributorPolygon: updateValue };
};
export const removeDistributorFromPolygonFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };

  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );

  return { ...state, removeDistributorPolygon: updateValue };
};

export const DispatchToDriver = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, DispatchDriver: updateValue };
};
export const DispatchToDriverSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };

  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.res?.entity?.webHookResult?.messageFa
        ? action.res?.entity?.webHookResult?.status +
          " - " +
          action.res?.entity?.webHookResult?.messageFa
        : action.res?.messageFa
      : action.res?.entity?.webHookResult?.message
      ? action.res?.entity?.webHookResult?.status +
        " - " +
        action.res?.entity?.webHookResult?.message
      : action.res?.message,
    "success"
  );

  return { ...state, DispatchDriver: updateValue };
};
export const DispatchToDriverFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };

  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );

  return { ...state, DispatchDriver: updateValue };
};

export const getPlanStatus = (state, action) => {
  const updateValue = {
    request: action.params,
    response: null,
    error: null,
  };
  return { ...state, PlanStatus: updateValue };
};
export const getPlanStatusSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res.planStatus,
    error: null,
  };

  return { ...state, PlanStatus: updateValue };
};
export const getPlanStatusFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };

  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );

  return { ...state, PlanStatus: updateValue };
};

export const getPlanVehicleConfig = (state, action) => {
  const updateValue = {
    request: action.params,
    response: null,
    error: null,
  };
  return { ...state, PlanVehicleConfig: updateValue };
};
export const getPlanVehicleConfigSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res?.entity,
    error: null,
  };

  return { ...state, PlanVehicleConfig: updateValue };
};
export const getPlanVehicleConfigFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };

  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );

  return { ...state, PlanVehicleConfig: updateValue };
};

export const planReset = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, PlanReset: updateValue };
};
export const planResetSuccess = (state) => {
  const updateValue = {
    request: null,
    response: true,
    error: null,
  };

  return { ...state, PlanReset: updateValue };
};
export const planResetFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, PlanReset: updateValue };
};

export const getPlanPreviewInfo = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, PreviewInfo: updateValue };
};
export const getPlanPreviewInfoSuccess = (state, action) => {
  
  const updateValue = {
    request: null,
    response: action.res?.entity,
    error: null,
  };

  return { ...state, PreviewInfo: updateValue };
};
export const getPlanPreviewInfoFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );
  return { ...state, PreviewInfo: updateValue };
};

export const driverActivation = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, driverActivation: updateValue };
};
export const driverActivationSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };

  return { ...state, driverActivation: updateValue };
};
export const driverActivationFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };

  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );

  return { ...state, driverActivation: updateValue };
};

export const getNextPrevPlan = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
    state: action.state,
  };
  return { ...state, NextPrevPlan: updateValue };
};
export const getNextPrevPlanSuccess = (state, action) => {
  const planId = action.res.entity[state.NextPrevPlan.state];
  const updateValue = {
    ...state.NextPrevPlan,
    request: null,
    response: planId,
    error: null,
  };

  return { ...state, NextPrevPlan: updateValue, planId };
};
export const getNextPrevPlanFail = (state, action) => {
  const updateValue = {
    ...state.NextPrevPlan,
    request: null,
    response: null,
    error: action.error,
  };

  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error"
  );

  return { ...state, NextPrevPlan: updateValue };
};

export const getMissionStatusExcel = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, MissionStatusExcel: updateValue };
};
export const getMissionStatusExcelSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  downloadItem(
    action.res.fileData.contentType,
    action.res.fileData.fileContents,
    action.res.fileData.fileDownloadName
  );

  return { ...state, MissionStatusExcel: updateValue };
};
export const getMissionStatusExcelFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };

  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error",
    4000
  );

  return { ...state, MissionStatusExcel: updateValue };
};

export const autoAssign = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, autoAssign: updateValue };
};
export const autoAssignSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res?.entity,
    error: null,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl" ? action.res?.messageFa : action.res?.message,
    "success"
  );
  return { ...state, autoAssign: updateValue };
};
export const autoAssignFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };

  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error",
    4000
  );

  return { ...state, autoAssign: updateValue };
};

export const requestPolygon = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, RequestVehicle: updateValue };
};
export const requestPolygonSuccess = (state) => {
  const updateValue = {
    request: null,
    response: true,
    error: null,
  };
  return { ...state, RequestVehicle: updateValue };
};
export const requestPolygonFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };

  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error",
    4000
  );

  return { ...state, RequestVehicle: updateValue };
};

export const getCityLayers = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, cityLayers: updateValue };
};
export const getCityLayersSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, cityLayers: updateValue };
};
export const getCityLayersFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };

  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error",
    4000
  );

  return { ...state, cityLayers: updateValue };
};

export const autoAssignMicrohubs = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, autoAssignMicrohubs: updateValue };
};
export const autoAssignMicrohubsSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, autoAssignMicrohubs: updateValue };
};
export const autoAssignMicrohubsFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };

  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error",
    4000
  );
  return { ...state, autoAssignMicrohubs: updateValue };
};

export const savePlanPreview = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, savePlanPreview: updateValue };
};
export const savePlanPreviewSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, savePlanPreview: updateValue };
};
export const savePlanPreviewFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };

  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error",
    4000
  );
  return { ...state, savePlanPreview: updateValue };
};

export const addNewPinToPlan = (state, action) => {
  const updateValue = {
    request: action.plan,
    response: null,
    error: null,
  };
  return { ...state, AddNewLastPin: updateValue };
};

export const addNewPinToPlanSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, AddNewLastPin: updateValue };
};

export const addNewPinToPlanFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, AddNewLastPin: updateValue };
};

export const getChatMessages = (state, action) => {
  const updateValue = {
    request: action,
    response: null,
    error: null,
  };
  return { ...state, chatMessages: updateValue };
};

export const getChatMessagesSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, chatMessages: updateValue };
};

export const getChatMessagesFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, chatMessages: updateValue };
};

export const EditVehicleName = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, EditVehicleName: updateValue };
};

export const EditVehicleNameSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };

  const planData = state.mainPlanData.polygons.map((poly) => {
    if (poly.subPlan.uid === action.data.subPlanId && action.data.vehicleName)
      return { ...poly, vehicleName: action.data.vehicleName };
    if (
      poly.subPlan.uid === action.data.subPlanId &&
      action.data.midMileVehicleName
    )
      return { ...poly, midMileVehicleName: action.data.midMileVehicleName };
    return poly;
  });
  const newSelectedPolygon = planData.find(
    (poly) => poly.subPlan.uid === action.data.subPlanId
  );

  Notification.pushNotif(
    i18n.dir() === "rtl" ? action.res?.messageFa : action.res?.message,
    "success"
  );
  return {
    ...state,
    MapItems: { ...state.MapItems, selectedPolygon: newSelectedPolygon },
    EditVehicleName: updateValue,
    mainPlanData: { ...state.mainPlanData, polygons: planData },
  };
};

export const EditVehicleNameFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error",
    4000
  );
  return { ...state, EditVehicleName: updateValue };
};

export const dispatchToAllAssignedDrivers = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, dispatchToAllAssignedDrivers: updateValue };
};

export const dispatchToAllAssignedDriversSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl" ? action.res?.messageFa : action.res?.message,
    "success"
  );
  return { ...state, dispatchToAllAssignedDrivers: updateValue };
};

export const dispatchToAllAssignedDriversFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(
    i18n.dir() === "rtl"
      ? action.error.response?.data?.messageFa
      : action.error.response?.data?.message,
    "error",
    4000
  );
  return { ...state, dispatchToAllAssignedDrivers: updateValue };
};
